import React from "react";
import { CheckedInTextArea } from "src/components/CheckedIn/CheckedInContentStyles";
import { EnumSurveyType } from "../components/Enums";
import { AppSurvey, QuestionType, SurveyQuestion } from "./surveyApi";
import { questionType, SURVEY_CHOICES } from "./surveyAnswers";
import { ChoiceGroup, ChoiceLabel, QuestionField, SurveyError } from "./SurveyViewerStyles";

interface SurveyQuestionInputProps {
    survey: AppSurvey;
    question: SurveyQuestion;
    answer: string;
    disabled: boolean;
    error: boolean;
    onChange: (value: string) => void;
}

export function SurveyQuestionInput({ survey, question, answer, disabled, error, onChange }:
    SurveyQuestionInputProps): React.ReactElement {
    const type: QuestionType = questionType(survey, question);
    const choices = SURVEY_CHOICES[type];
    const questionId: string = `survey-question-${question.uuid}`;
    const errorId: string = `${questionId}-error`;
    const legendId: string = `${questionId}-label`;
    return <QuestionField id={questionId} tabIndex={-1} disabled={disabled}>
        <legend id={legendId}>{question.question}</legend>
        {type === EnumSurveyType.FEEDBACK ?
            <CheckedInTextArea aria-labelledby={legendId} placeholder="Your answer…" value={answer}
                required aria-invalid={error} aria-describedby={error ? errorId : undefined}
                name={question.uuid} onChange={event => onChange(event.target.value)} />
            : choices?.length > 0 ? <ChoiceGroup $count={choices.length} role="radiogroup"
                aria-labelledby={legendId} aria-required="true" aria-invalid={error}
                aria-describedby={error ? errorId : undefined}>
                {choices.map(choice => {
                    const selected: boolean = type === EnumSurveyType.RATING
                        ? Number(answer) >= Number(choice.value) : answer === choice.value;
                    return <ChoiceLabel key={choice.value} $selected={selected} $type={type} title={choice.label}
                        $dimmed={type === EnumSurveyType.YESNO && answer !== "" && !selected}>
                        <input type="radio" name={question.uuid} aria-label={choice.label} value={choice.value}
                            checked={answer === choice.value} onChange={() => onChange(choice.value)} required />
                        <img src={selected && choice.selectedImage ? choice.selectedImage : choice.image} alt="" />
                    </ChoiceLabel>;
                })}
            </ChoiceGroup> : <SurveyError role="alert">This question type is unavailable.</SurveyError>}
        {error && <SurveyError id={errorId} role="alert">
            {type === EnumSurveyType.FEEDBACK ? "Please enter an answer." : "Please choose an answer."}
        </SurveyError>}
    </QuestionField>;
}
